export const getShadowTooltipContainer = (trigger: HTMLElement) => trigger.parentElement ?? trigger

export const defaultTooltipStyles = {
	body: { fontSize: 12, lineHeight: "16px", padding: "6px 8px", minHeight: "auto" },
}

export const compactTooltipStyles = {
	body: { fontSize: 10, lineHeight: "12px", padding: "3px 6px", minHeight: "auto" },
}

// Portals to the sidebar root instead, so a multi-line tooltip is not clipped by the sidebar's
// scrolling content area (#1527: the eref list cut off the first line at its top edge).
export const getSidebarTooltipContainer = (trigger: HTMLElement) =>
	trigger.closest<HTMLElement>("[data-hotkey-sidebar]") ?? getShadowTooltipContainer(trigger)
